import { FormProps, AppFormTabProps } from 'components/AppFormLayout/AppFormData'

export const EntityEditFieldFormData = [
	{
		tabId: 0,
		title: '新分区',
		isHidden: false,
		appFormBlockList: [
			{
				colNumber: 1,
				title: '',
				labelWidth: 120,
				appFormItemList: [
					{
						type: 'Input',
						dataType: 'string',
						field: 'displayName',
						label: '中文名称',
                        placeholder:"请输入中文名称",
                        req: true
					},
					{
						type: 'Input',
						dataType: 'string',
						field: 'name',
                        label: '英文名称',
                        placeholder:"请输入英文名称",
						req: true,
                    },
                    {
						type: 'Input',
						dataType: 'string',
						field: 'length',
                        label: '字段长度',
                        placeholder:"请输入字段长度",
						req: true,
                    },
                    {
						type: 'Select',
						isHidden: false,
						dataType: 'string',
						field: 'attributeType',
                        label: '显示字段类型',
                        placeholder:"请输入字段类型",
                        req: true,
						options: [{ label: '日期', value: "datetime" }, { label: 'id类型', value: "numeric" }, { label: '文本', value: "nvarchar" }],
                    },
					{
						type: 'Select',
						isHidden: false,
						dataType: 'boolean',
						field: 'isNullable',
                        label: '是否允许为空',
						req: true,
						options: [{ label: '是', value: true }, { label: '否', value:false }],
                    },
                    {
						type: 'Select',
						isHidden: false,
						dataType: 'boolean',
						field: 'isPrimaryAttribute',
                        label: '是否主键字段',
						req: true,
						options: [{ label: '是', value: true }, { label: '否', value: false }],
                    },
                    {
						type: 'Select',
						isHidden: false,
						dataType: 'boolean',
						field: 'isSystem',
                        label: '是否系统级',
						req: true,
						options: [{ label: '是', value: true }, { label: '否', value: false }],
					},
					{
						type: 'Input',
						isHidden: true,
						dataType: 'number',
						field: 'organ_id',
						label: '公司id',
						req: true,
					},
				],
			},
		],
	},
] as any[]



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/components/EntityEditFieldFormData.tsx